import { Pipe, PipeTransform } from '@angular/core';
import { FilterListItemModel } from '../../models/ts-filter.types';

@Pipe({ name: 'tsFieldFromName' })
export class TsFieldFromNamePipe implements PipeTransform {
  transform(value: string, fields: FilterListItemModel[]): FilterListItemModel {
    return fields.find(({ name }) => name === value);
  }
}
